// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"505":"753fb73b","962":"5cedc9ee"}[chunkId] + ".css";
};